var showAllLocationsHandler = require('./show-all-locations-handler');

module.exports = function () {
    if ($('.careers-search').length) {
        var $careersTypeAheadContainer = $('.careers-search-header__type-ahead-container');

        var resizeFacets = function () {
            $('.careers-search-facet').each(function () {
                var finalNode = $(this).find('.careers-search-facet-options, .careers-search-facets-fields-open-button').last();

                var newHeight = finalNode.position().top + finalNode.outerHeight() + 24;

                $(this).height(newHeight);
            });
        };

        resizeFacets();
        setTimeout(resizeFacets, 100);
        $(window).resize(resizeFacets);

        $('.careers-search-body-container').find('.careers-search-facets-fields-open-button').modaal({
            content_source: '#careers-search-fields-show-more-modal-content',
            custom_class: 'careers-search-fields-show-more-modal',
            hide_close: true,
            overlay_close: false
        });

        var resizeQuickSearches = function () {
            var newHeight = $('.careers-search-header-quick-search').last().position().top + $('.careers-search-header-quick-search').last().outerHeight();
            $('.careers-search-header-quick-searches-container').height(newHeight);
        };

        resizeQuickSearches();
        setTimeout(resizeQuickSearches, 100);
        $(window).resize(resizeQuickSearches);

        var autoComplete;

        ICF.Utils.LoadScript('https://maps.googleapis.com/maps/api/js?key=' + window.ICFGoogleMapsKey + '&libraries=places', function () {
            autoComplete = new google.maps.places.Autocomplete($('#location')[0], {
                types: ['(regions)']
            });
        });

        var getOpenFacets = function () {
            var openFacets = [];

            if ($('#careersSearchFacetDays').hasClass('careers-search-facet-open')) {
                openFacets.push('days');
            }

            if ($('#careersSearchFacetPersona').hasClass('careers-search-facet-open')) {
                openFacets.push('role');
            }

            if ($('#careersSearchFacetField').hasClass('careers-search-facet-open')) {
                openFacets.push('field');
            }

            if ($('#careersSearchFacetSchedule').hasClass('careers-search-facet-open')) {
                openFacets.push('schedule');
            }

            if ($('#careersSearchFacetLevel').hasClass('careers-search-facet-open')) {
                openFacets.push('type');
            }

            return openFacets;
        };

        var getQueryString = function (includeOpenFacets) {
            var queryStringComponents = {};

            queryStringComponents.location = encodeURIComponent($('#location').val());
            queryStringComponents.keywords = encodeURIComponent($('#keywords').val());
            queryStringComponents.role = $('#careersSearchFacetPersona').find(':checked').toArray().map(function (input) { return encodeURIComponent($(input).val()); }).join('|');
            queryStringComponents.days = $('#careersSearchFacetDays').find(':checked').toArray().map(function (input) { return encodeURIComponent($(input).val()); }).join('|');
            queryStringComponents.schedule = $('#careersSearchFacetSchedule').find(':checked').toArray().map(function (input) { return encodeURIComponent($(input).val()); }).join('|');
            queryStringComponents.type = $('#careersSearchFacetLevel').find(':checked').toArray().map(function (input) { return encodeURIComponent($(input).val()); }).join('|');
            queryStringComponents.order = encodeURIComponent($('.careers-search-results-sort-container select').val());
            queryStringComponents.category = $('#careersSearchFacetCategory').find(':checked').toArray().map(function (input) { return encodeURIComponent($(input).val()); }).join('|');
            queryStringComponents.areaofinterest = $('#careersSearchFacetAreaOfInterest').find(':checked').toArray().map(function (input) { return encodeURIComponent($(input).val()); }).join('|');

            if (includeOpenFacets) {
                queryStringComponents.openfacets = getOpenFacets().join('|');
            }

            if (queryStringComponents.days === 'any') {
                queryStringComponents.days = '';
            }

            var page = $('#careersSearchCurrentPage').val();

            if (page !== '1') {
                queryStringComponents.page = page;
            }

            var queryString = Object.keys(queryStringComponents).filter(function (key) {
                return queryStringComponents[key];
            }).map(function (key) {
                return key + '=' + queryStringComponents[key];
            }).join('&');

            return queryString;
        };

        var updateQueryString = function () {
            var queryString = getQueryString();

            history.replaceState({}, window.title, window.location.pathname + (queryString.length ? '?' + queryString : ''));
        };

        var loadResults = function (callback) {
            $('.careers-search-results').parent().css('transition-delay', '0s').css('opacity', '0.15').css('pointer-events', 'none');
            $('.careers-search-body-container').append('<img src="/includes/icf/img/globals/loading_spinner.gif" style="position: absolute;left: 50%; top: 30px; background-color: rgba(118,133,145,1);border-radius: 32px;padding: 16px;transform: translateX(-50%);width: 64px;">');

            var queryString = getQueryString(true);

            var url = '/icfapi/careerssearch/loadmore' + (queryString.length ? '?' + queryString : '');

            $.get(url, {}, function (data) {
                $('.careers-search-body-container').html(data);
                $('.careers-search-fields-show-more-modal').remove();
                resizeFacets();
                if (callback) {
                    callback();
                }
                $('.careers-search-body-container').find('.careers-search-facets-fields-open-button').modaal({
                    content_source: '#careers-search-fields-show-more-modal-content',
                    custom_class: 'careers-search-fields-show-more-modal',
                    hide_close: true,
                    overlay_close: false
                });

                ICF.Modules.Careers.Search.ApplyCTAHandler();
                showAllLocationsHandler();
            });
        };

        $('.careers-search-header-fields-submit').click(function () {
            $('#careersSearchCurrentPage').val(1);
            updateQueryString();
            loadResults();
            return false;
        });

        $('.careers-search-header-fields input').keyup(function () {
            if ($(this).val().length) {
                $(this).closest('.careers-search-header-fields-keywords').addClass('careers-search-header-fields-filled');
            } else {
                $(this).closest('.careers-search-header-fields-keywords').removeClass('careers-search-header-fields-filled');
            }
        });

        $('.careers-search-header-field-clear').click(function () {
            $(this).siblings('input').val('').focus();
            $(this).closest('.careers-search-header-fields-keywords').removeClass('careers-search-header-fields-filled');

            var $typeAheadHidden = $careersTypeAheadContainer.find('.type-ahead-hidden');
            var $typeAheadVisible = $careersTypeAheadContainer.find('.type-ahead-visible');

            $typeAheadHidden.text('');
            $typeAheadVisible.text('');
        });

        $('#keywords, #location').keypress(function (e) {
            if (e.which === 13) {
                $('#careersSearchCurrentPage').val(1);
                updateQueryString();
                loadResults();
                return false;
            }

            return true;
        });

        $('.careers-search-header-quick-searches-more').click(function () {
            $('.careers-search-header-quick-searches-container').addClass('careers-search-header-quick-searches-open');
        });

        $('.careers-search').on('click', '.careers-search-header-quick-search,.careers-search-results-no-results-quick-search', function () {
            $('#keywords,#location').val('');
            $('#careersSearchFacetPersona').addClass('careers-search-facet-open');
            $('#careersSearchFacetPersona').find('input').prop('checked', false);
            $('[value="' + $(this).data('value') + '"]').click();
            $('body, html').animate({ scrollTop: $('.careers-search-results-header').offset().top - 48 }, 500);
        });

        $('.careers-search-body-container').on('click', '.careers-search-facet-title', function () {
            var $facet = $(this).parents('.careers-search-facet').first();
            $facet.toggleClass('careers-search-facet-open');
            $facet.find('.circle-plus-minus-icon').toggleClass("circle-plus-minus-icon--is-active");
        });

        $('.careers-search-body-container').on('change', '.careers-search-facet-option input', function (event) {
            if ($('.careers-search-fields-show-more-modal').length) {
                $('.careers-search-facets-fields-open-button').modaal('close');
            }

            $('[value="' + $(event.target).val() + '"]').prop('checked', $(event.target).is(':checked'));
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            $('#careersSearchCurrentPage').val(1);
            updateQueryString();
            loadResults();
        });

        $('.careers-search-body-container').on('click', '.careers-search-facets-mobile-title', function () {
            $(this).parents('.careers-search-facets').toggleClass('careers-search-facets-open');
        });

        $('.careers-search-body-container').on('change', '.careers-search-results-sort-container select', function () {
            $('#careersSearchCurrentPage').val(1);
            updateQueryString();
            loadResults();
        });

        $('.careers-search-body-container').on('click', '.careers-search-results-pagination-item', function () {
            $('html, body').animate({ scrollTop: 0 }, 500);
            $('#careersSearchCurrentPage').val($(this).data('value'));
            updateQueryString();
            loadResults();
        });

        $('.careers-search-body-container').on('click', '.careers-search-results-pagination-item-prev', function () {
            $('body, html').animate({ scrollTop: $('.careers-search-results-header').offset().top - 48 }, 500);
            $('#careersSearchCurrentPage').val(parseInt($('#careersSearchCurrentPage').val()) - 1);
            updateQueryString();
            loadResults();
        });

        $('.careers-search-body-container').on('click', '.careers-search-results-pagination-item-next', function () {
            $('body, html').animate({ scrollTop: $('.careers-search-results-header').offset().top - 48 }, 500);
            $('#careersSearchCurrentPage').val(parseInt($('#careersSearchCurrentPage').val()) + 1);
            updateQueryString();
            loadResults();
        });

        $('body').on('click', '.careers-search-fields-show-more-modal .modal-button-cancel', function () {
            var $modal = $(this).parents('.careers-search-fields-show-more-modal').first();

            $('#careersSearchFacetCategory input').each(function () {
                $modal.find('input[value="' + $(this).val() + '"]').prop('checked', $(this).is(':checked'));
            });

            $('#careersSearchFacetAreaOfInterest input').each(function () {
                $modal.find('input[value="' + $(this).val() + '"]').prop('checked', $(this).is(':checked'));
            });

            $('.careers-search-facets-fields-open-button').modaal('close');

            return false;
        });

        $('body').on('click', '.careers-search-fields-show-more-modal .modal-button-apply', function () {
            $(this).parents('.careers-search-fields-show-more-modal').find('input').each(function (elem) {
                $('#careersSearchFacetCategory input[value="' + $(this).val() + '"]').prop('checked', $(this).is(':checked'));
                $('#careersSearchFacetAreaOfInterest input[value="' + $(this).val() + '"]').prop('checked', $(this).is(':checked'));
            });

            $('.careers-search-facets-fields-open-button').modaal('close');

            updateQueryString();
            loadResults();

            return false;
        });

        ICF.Modules.Careers.Search.ApplyCTAHandler();
        showAllLocationsHandler();        
    }
};